<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="width" :height="height" viewBox="0 0 81 100">
    <g :fill="iconColor" fill-rule="evenodd">
      <path
        d="M49.672 67.69c-.44-.362-1.029-.544-1.765-.544-.896 0-1.69.174-2.383.523v-2.546l3.206-2.785h-5.09v-3.285h9.898v2.937l-2.946 2.61c.795.204 1.567.632 2.318 1.284.895.784 1.343 1.857 1.343 3.22 0 1.698-.607 3.032-1.82 4.004-1.198.986-2.693 1.48-4.483 1.48-1.79 0-3.365-.421-4.722-1.263v-3.633c1.487.972 2.996 1.458 4.527 1.458.75 0 1.368-.185 1.852-.555.484-.37.725-.867.725-1.49 0-.58-.22-1.052-.66-1.415zm-20.046 6.593v-15.23h6.758c1.703 0 3.046.442 4.028 1.327.997.885 1.495 2.03 1.495 3.438 0 1.407-.498 2.56-1.495 3.459-.982.885-2.325 1.327-4.028 1.327h-2.86v5.679h-3.898zm40.713 19.043H15.874c-2.259 0-4.098-1.847-4.098-4.118v-4.762h50.775c2.354 0 4.262-1.915 4.262-4.28V54.197c0-2.365-1.908-4.281-4.262-4.281H11.776V10.625c0-2.264 1.84-4.112 4.098-4.112l37.494-.04v13.923c0 4.067 3.284 7.368 7.336 7.368l13.576-.039.152 61.483c0 2.271-1.834 4.118-4.093 4.118zM11.302 59.053h3.877l3.834 5.852 3.855-5.852h3.855v15.23h-3.877v-9.29l-2.707 4.09h-2.144l-2.795-4.09v9.29h-3.898v-15.23zM55.792 0H15.874C10.042 0 5.295 4.771 5.295 10.625v39.292H4.263C1.908 49.917 0 51.833 0 54.198v25.967c0 2.366 1.908 4.281 4.263 4.281h1.032v4.762c0 5.861 4.747 10.626 10.579 10.626h54.465c5.829 0 10.576-4.765 10.576-10.626v-64.06L55.792 0z"
      />
      <path
        d="M37.456 64.982c.339-.269.509-.642.509-1.12 0-.48-.166-.85-.499-1.11-.332-.262-.787-.392-1.364-.392h-2.578v3.024h2.578c.563 0 1.014-.134 1.354-.402M41.39 13.968L26.085 18.32c-.466.134-.786.561-.786 1.047v14.746a4.269 4.269 0 0 0-2.166-.605c-2.389 0-4.331 1.951-4.331 4.351s1.942 4.351 4.331 4.351c2.39 0 4.332-1.951 4.332-4.351v-13.32l13.14-3.73v8.953a4.267 4.267 0 0 0-2.167-.605c-2.389 0-4.331 1.951-4.331 4.35 0 2.4 1.942 4.352 4.331 4.352 2.39 0 4.332-1.951 4.332-4.351V15.015c0-.72-.685-1.244-1.38-1.047"
      />
    </g>
  </svg>
</template>

<script>
  export default {
    name: 'icon-mp3',
    props: {
      width: {
        type: [Number, String],
        default: 81
      },
      height: {
        type: [Number, String],
        default: 100
      },
      iconColor: {
        type: String,
        default: 'currentColor'
      }
    }
  };
</script>
